import { DatePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core"
import { Router } from "@angular/router";
import { Chart } from "chart.js"
import { DadosRelatorio } from "../../model/dadosRelatorio";
import { RelatorioServico } from "../../servicos/relatorio/relatorio.servico";
import { loadCldr, L10n } from "@syncfusion/ej2-base";
import { LiberacaoSaldo } from "../../model/liberacaoSaldo";
import { PedidoCancelado } from "../../model/PedidoCancelado";
import { LiberacaoAlcada } from "../../model/liberacaoAlcada";

//variavel para utilizar jquery
declare var $: any;
declare var require: any;

loadCldr(
  require("cldr-data/main/pt/numbers.json"),
  require("cldr-data/main/pt/ca-gregorian.json"),
  require("cldr-data/supplemental/numberingSystems.json"),
  require("cldr-data/main/pt/timeZoneNames.json"),
  require('cldr-data/supplemental/weekdata.json') // To load the culture based first day of week
);

@Component({
  selector: "app-liberacoes-relatorio",
  templateUrl: "./liberacoes.relatorio.component.html",
  styleUrls: ["./liberacoes.relatorio.component.css"]
})
export class LiberacoesRelatorioComponent implements OnInit {
  constructor(private router: Router, private relatorioServico: RelatorioServico, public datepipe: DatePipe) {

  }

  public chart: any;
  public dadosRelatorio: DadosRelatorio[];
  public ativar_spinner: boolean = false;
  public minDate: Date = new Date("01/01/2021");
  public maxDate: Date = new Date("12/31/2099");
  public dateValue: Date = new Date();
  public dataInicio: Date = new Date();
  public dataFim: Date = new Date();
  public tipoPesquisa: number = 1;
  public listaLiberacaoSaldo: LiberacaoSaldo[] = [];
  public listaPedidoCancelado: PedidoCancelado[] = [];
  public listaLiberacoesAlcada: LiberacaoAlcada[] = [];
  pag: Number = 1;
  contador: Number = 30;

  ngOnInit(): void {
    $(() => {
      $(document).ready(function () {

      })
    });
    //this.createChart();
  }

  public pesquisar() {
    this.pag = 1;
    this.ativar_spinner = true;
    var relatorio = new DadosRelatorio();
    relatorio.dataInicio = this.dataInicio;
    relatorio.dataFim = this.dataFim;
    relatorio.tipoPesquisa = this.tipoPesquisa;

    if (this.tipoPesquisa == 1) {
      this.relatorioServico.obterLiberacoesSaldo(relatorio)
        .subscribe(
          retorno => {
            this.listaLiberacaoSaldo = retorno;
            this.ativar_spinner = false;
          },
          err => {
            console.log(err.error);
            this.ativar_spinner = false;
          }
        )
    }
    else if (this.tipoPesquisa == 2) {
      this.relatorioServico.obterLiberacoesPedidosCancelados(relatorio)
        .subscribe(
          retorno => {
            this.listaPedidoCancelado = retorno;
            this.ativar_spinner = false;
          },
          err => {
            console.log(err.error);
            this.ativar_spinner = false;
          }
        )
    }
    else if (this.tipoPesquisa == 3 || this.tipoPesquisa == 4) {

      relatorio.tipoPesquisa = relatorio.tipoPesquisa - 2;
      this.relatorioServico.obterLiberacoesAlcada(relatorio)
        .subscribe(
          retorno => {
            this.listaLiberacoesAlcada = retorno;
            this.ativar_spinner = false;
          },
          err => {
            console.log(err.error);
            this.ativar_spinner = false;
          }
        )
    }
  }
}
